import type { UserId } from "@inrev/common";
import { useEffect, useEffectEvent } from "react";
import {
	ACTIVE_AGENT_FOLLOWER_REQUIRED,
	type ActiveAgentPreview,
	hasActiveAgentFollower,
} from "./hasActiveAgentFollower";

export const useRequireActiveAgentFollower = (
	followers: UserId[] | undefined,
	agentPreviews: ActiveAgentPreview[] | undefined,
	{
		setError,
		clearError,
		hasManualError,
	}: {
		setError: (message: string) => void;
		clearError: () => void;
		hasManualError: boolean;
	},
) => {
	const onInvalid = useEffectEvent(setError);
	const onValid = useEffectEvent(clearError);

	useEffect(() => {
		if (!followers?.length || !agentPreviews) return;
		if (!hasActiveAgentFollower(followers, agentPreviews)) {
			onInvalid(ACTIVE_AGENT_FOLLOWER_REQUIRED);
			return;
		}
		if (hasManualError) {
			onValid();
		}
	}, [followers, agentPreviews, hasManualError]);
};
